import type { LegalDocument } from '../types';

/** Источник: «Политика конфиденциальности.docx». Файл сгенерирован — правки вносите в документ. */
export const doc: LegalDocument = {
  title: 'Политика конфиденциальности для пользователей приложения Aura',
  blocks: [
    {
      kind: 'heading',
      number: '1.',
      text: 'Общие положения',
    },
    {
      kind: 'para',
      number: '1.1.',
      text: 'Настоящая Политика конфиденциальности (далее — Политика) устанавливает порядок обработки и защиты персональных данных пользователей мобильного приложения Aura (далее — Приложение).',
    },
    {
      kind: 'para',
      number: '1.2.',
      text: 'Обработка персональных данных осуществляется ООО «Falcon», зарегистрированным в соответствии с законодательством Республики Абхазия (ОГРН 108РА000782, ИНН 11008213, юридический адрес: проспект Мира 16, г. Сухум, Республика Абхазия) (далее — Компания).',
    },
    {
      kind: 'para',
      number: '1.3.',
      text: 'Настоящая Политика разработана с учётом законодательства Республики Абхазия, регулирующего защиту информации, конфиденциальность, договорные отношения и обработку данных пользователей. В отношении пользователей из иных юрисдикций Компания учитывает применимые требования законодательства таких юрисдикций, включая требования GDPR для пользователей из Европейского союза, если такие требования подлежат применению к деятельности Компании.',
    },
    {
      kind: 'para',
      text: 'К настоящей политике могут быть применены иные национальные нормативные акты о защите данных, если они обеспечивают уровень защиты не ниже предусмотренного настоящей Политикой.',
    },
    {
      kind: 'para',
      number: '1.4.',
      text: 'Настоящая Политика распространяется на обработку любых персональных данных, полученных Компанией при использовании Приложения, независимо от способа регистрации, устройства или страны нахождения пользователя.',
    },
    {
      kind: 'para',
      number: '1.5.',
      text: 'Если Пользователь является гражданином, Российской Федерации и стран СНГ, обработка его персональных данных осуществляется в соответствии с Политикой конфиденциальности, размещённой по адресу: https://aura-vibe.site/privacy_policy.',
    },
    {
      kind: 'para',
      number: '1.6.',
      text: 'Используя Приложение, Пользователь подтверждает, что ознакомился с настоящей Политикой, соглашается на обработку персональных данных и обязуется соблюдать условия Пользовательского соглашения.',
    },
    {
      kind: 'para',
      number: '1.7.',
      text: 'Целью обработки персональных данных является обеспечение корректной работы Приложения, предоставление доступа к функционалу, выполнение договорных обязательств Компании и соблюдение требований законодательства стран, применимых к деятельности Компании.',
    },
    {
      kind: 'para',
      number: '1.8.',
      text: 'Компания руководствуется следующими принципами обработки персональных данных:',
    },
    {
      kind: 'bullet',
      text: 'а) законность и прозрачность — обработка осуществляется на основании согласия пользователя или договора;',
    },
    {
      kind: 'bullet',
      text: 'б) минимизация данных — собирается только информация, необходимая для целей обработки;',
    },
    {
      kind: 'bullet',
      text: 'в) ограничение хранения — данные хранятся не дольше, чем это необходимо;',
    },
    {
      kind: 'bullet',
      text: 'г) точность и актуальность — пользователи имеют право обновлять или исправлять свои данные;',
    },
    {
      kind: 'bullet',
      text: 'д) безопасность и конфиденциальность — Компания использует технические и организационные меры для защиты данных от несанкционированного доступа.',
    },
    {
      kind: 'para',
      number: '1.9.',
      text: 'Настоящая Политика является неотъемлемой частью Пользовательского соглашения, Политики защиты детей и',
    },
    {
      kind: 'para',
      text: 'Политики использования файлов cookie, которые доступны в Приложении и на официальном сайте https://aura-vibe.site.',
    },
    {
      kind: 'heading',
      number: '2.',
      text: 'Состав и категории обрабатываемых данных',
    },
    {
      kind: 'para',
      number: '2.1.',
      text: 'В рамках использования Приложения Компания может собирать, хранить и обрабатывать следующие категории персональных данных Пользователя:',
    },
    {
      kind: 'bullet',
      text: 'а) Регистрационные данные — имя, фамилия, дата рождения, адрес электронной почты, номер телефона, фотография профиля, информация о гражданстве или стране проживания.',
    },
    {
      kind: 'bullet',
      text: 'б) Данные, добровольно предоставленные Пользователем, в том числе:',
    },
    {
      kind: 'para',
      text: 'О контент, размещаемый в Приложении (публикации, комментарии, фотографии, видео, аудио, тексты, голосовые сообщения);',
    },
    {
      kind: 'para',
      text: 'О информация, указанная в профиле (описание, навыки, профессия, язык общения, интересы и т.д.);',
    },
    {
      kind: 'para',
      text: 'О переписка и общение в чате, взаимодействие с другими пользователями, отзывы и оценки.',
    },
    {
      kind: 'bullet',
      text: 'в) Технические данные, автоматически передаваемые устройством при использовании Приложения:',
    },
    {
      kind: 'para',
      text: 'О IP-адрес, тип и модель устройства, версия операционной системы, системный язык, версия Приложения, дата и время посещения;',
    },
    {
      kind: 'para',
      text: 'О данные о сбоях, ошибках, журналах работы и аналитике производительности;',
    },
    {
      kind: 'para',
      text: 'О файлы cookie, идентификаторы устройств (IDFA, Android ID, Firebase ID, GAID и иные SDK-токены).',
    },
    {
      kind: 'bullet',
      text: 'г) Данные о действиях Пользователя в Приложении:',
    },
    {
      kind: 'para',
      text: 'О просмотры страниц и разделов, клики, история поиска и навигации;',
    },
    {
      kind: 'para',
      text: 'О использование функций (чат, знакомства, публикации, «Специалист», «Партнёр», карта мероприятий, покупка',
    },
    {
      kind: 'para',
      text: 'Kelvin и подписки);',
    },
    {
      kind: 'para',
      text: 'О геолокация (при активации функций, требующих доступа к местоположению).',
    },
    {
      kind: 'bullet',
      text: 'д) Данные о платежах, совершённых через сторонние платёжные системы (Google Play, App Store, Stripe, PayPal и др.):',
    },
    {
      kind: 'para',
      text: 'О сумма, дата и время транзакции, тип подписки или услуги;',
    },
    {
      kind: 'para',
      text: 'О технические идентификаторы транзакций (без хранения полных данных банковских карт и реквизитов).',
    },
    {
      kind: 'bullet',
      text: 'е) Данные для проверки личности — фотографии, видео, документы или иная информация, предоставленная для подтверждения возраста, статуса или участия в определённых сервисах (разделы «Любовь» или «Специалист»).',
    },
    {
      kind: 'bullet',
      text: 'ж) Данные, полученные из внешних источников, если Пользователь дал согласие на интеграцию учётной записи (Google, Apple ID, Facebook или Telegram).',
    },
    {
      kind: 'para',
      number: '2.2.',
      text: 'Компания не запрашивает и не обрабатывает специальные категории персональных данных (сведения о расовой, этнической принадлежности, религии, политических взглядах, здоровье, биометрии или сексуальной ориентации), за исключением случаев, когда такие данные добровольно и явно предоставлены Пользователем с его согласия.',
    },
    {
      kind: 'para',
      number: '2.3.',
      text: 'Компания не обрабатывает биометрические данные (включая распознавание лиц) за пределами функционала верификации, требующего согласия Пользователя.',
    },
    {
      kind: 'para',
      number: '2.4.',
      text: 'Все данные собираются в соответствии с принципом минимизации данных: Компания получает только ту информацию, которая объективно необходима для предоставления услуг, указанных в Пользовательском соглашении.',
    },
    {
      kind: 'para',
      number: '2.5.',
      text: 'Компания может обрабатывать обезличенные (анонимизированные) данные, не позволяющие идентифицировать Пользователя. Такие данные используются для статистики, аналитики и оптимизации Приложения.',
    },
    {
      kind: 'para',
      number: '2.6.',
      text: 'Пользователь несёт ответственность за точность и актуальность предоставленных данных и имеет право в любое время обновить или удалить их через настройки профиля или обратившись в службу поддержки по адресу: support@aura-vibe.site.',
    },
    {
      kind: 'para',
      number: '2.7.',
      text: 'С явного согласия Пользователя Приложение считывает с Android Health Connect ежедневное количество шагов пользователя для отображения личного дневного и недельного индикатора шагов внутри Приложения в качестве фитнес-функции.',
    },
    {
      kind: 'bullet',
      text: 'Собираемые данные: количество шагов, записанных устройством Пользователя за день.',
    },
    {
      kind: 'bullet',
      text: 'Источник: Android Health Connect API.',
    },
    {
      kind: 'bullet',
      text: 'Цель: отображение собственного прогресса активности Пользователя в качестве персональной оздоровительной функции внутри Приложения.',
    },
    {
      kind: 'bullet',
      text: 'Хранение и передача: данные о количестве шагов могут передаваться на серверы Компании и связываться с учётной записью Пользователя исключительно для обеспечения согласованности индикатора на всех устройствах Пользователя. Данные шифруются при передаче.',
    },
    {
      kind: 'bullet',
      text: 'Распространение: данные о шагах не передаются другим пользователям, не передаются третьим лицам, не используются для рекламы, профилирования, скоринга, геймификации, видимой другим пользователям, страхования, трудоустройства или кредитных решений.',
    },
    {
      kind: 'bullet',
      text: 'Отзыв доступа: в любое время через Настройки Android ^ Приложения ^ Health Connect ^ Aura ^ Разрешения. После отзыва Приложение прекращает чтение новых данных о шагах.',
    },
    {
      kind: 'bullet',
      text: 'Удаление: Пользователь может запросить удаление всех сохранённых данных о шагах через процедуру удаления учётной записи в приложении или обратившись по адресу: privacy@aura-vibe.site.',
    },
    {
      kind: 'heading',
      number: '3.',
      text: 'Цели и правовые основания обработки персональных данных',
    },
    {
      kind: 'para',
      number: '3.1.',
      text: 'Компания обрабатывает персональные данные Пользователей исключительно в целях, связанных с функционированием, безопасностью и развитием Приложения, в том числе:',
    },
    {
      kind: 'bullet',
      text: 'а) регистрация и идентификация Пользователя для предоставления доступа к сервисам Приложения;',
    },
    {
      kind: 'bullet',
      text: 'б) выполнение договорных обязательств между Пользователем и Компанией, включая предоставление платных услуг, премиум-функций, подписок и виртуальной валюты Kelvin;',
    },
    {
      kind: 'bullet',
      text: 'в) персонализация контента и рекомендаций путём отображения релевантных пользователей, событий, мест и материалов;',
    },
    {
      kind: 'bullet',
      text: 'г) обеспечение безопасности, предотвращение мошенничества, несанкционированного доступа, нарушений правил поведения и иных злоупотреблений;',
    },
    {
      kind: 'bullet',
      text: 'д) информационные и сервисные уведомления, включая технические сообщения, изменения условий, напоминания и ответы службы поддержки;',
    },
    {
      kind: 'bullet',
      text: 'е) статистический и аналитический анализ для улучшения качества Приложения, интерфейса и пользовательского опыта;',
    },
    {
      kind: 'bullet',
      text: 'ж) соблюдение правовых и нормативных требований, включая хранение бухгалтерской и налоговой отчётности, ответы на запросы государственных органов и судебные решения;',
    },
    {
      kind: 'bullet',
      text: 'з) обеспечение функционирования систем модерации и защиты детей в соответствии с Политикой безопасности детей и правилами Google Play CSAE/CSAM.',
    },
    {
      kind: 'para',
      number: '3.2.',
      text: 'Правовыми основаниями обработки персональных данных являются:',
    },
    {
      kind: 'bullet',
      text: 'а) согласие Пользователя — добровольное и информированное, выраженное при регистрации, использовании Приложения или активации определённых функций;',
    },
    {
      kind: 'bullet',
      text: 'б) необходимость исполнения договора, стороной которого является Пользователь;',
    },
    {
      kind: 'bullet',
      text: 'в) законный интерес Компании — обеспечение защиты Приложения, предотвращение нарушений, повышение качества обслуживания при условии, что такие интересы не нарушают права Пользователя;',
    },
    {
      kind: 'bullet',
      text: 'г) юридическая обязанность Компании — соблюдение законодательных требований, включая налоговые, платёжные и нормативные предписания;',
    },
    {
      kind: 'bullet',
      text: 'д) жизненно важные интересы Пользователя — в случаях, когда обработка необходима для защиты жизни, здоровья или безопасности человека.',
    },
    {
      kind: 'para',
      number: '3.3.',
      text: 'Компания не осуществляет автоматизированное принятие решений (включая профилирование), которое может порождать юридические последствия или иным образом существенно затрагивать права Пользователя. Исключение составляют процессы персонализации контента и аналитики, не влияющие на юридические права.',
    },
    {
      kind: 'para',
      number: '3.4.',
      text: 'В случае изменения целей обработки персональных данных Компания обязуется:',
    },
    {
      kind: 'bullet',
      text: 'получить новое согласие Пользователя, если изменяются правовые основания обработки;',
    },
    {
      kind: 'bullet',
      text: 'уведомить Пользователя через Приложение, электронную почту или официальный сайт https://aura-vibe.site.',
    },
    {
      kind: 'para',
      number: '3.5.',
      text: 'Обработка персональных данных, переданных через сторонние сервисы (Google, Apple, Facebook и др.), регулируется отдельными политиками конфиденциальности этих сервисов. Компания получает только ту информацию, которая предоставлена Пользователем с его согласия, и ограничена объёмом, необходимым для функционирования Приложения.',
    },
    {
      kind: 'para',
      number: '3.6.',
      text: 'Все данные используются строго в указанных целях. Компания не продаёт, не обменивает и не передаёт персональные данные Пользователей третьим лицам в коммерческих целях.',
    },
    {
      kind: 'heading',
      number: '4.',
      text: 'Передача, хранение и трансграничная обработка персональных данных',
    },
    {
      kind: 'para',
      number: '4.1.',
      text: 'Персональные данные Пользователей могут передаваться третьим лицам и организациям только в случаях, прямо предусмотренных настоящей Политикой, Пользовательским соглашением или требованиями законодательства.',
    },
    {
      kind: 'para',
      number: '4.2.',
      text: 'Компания передаёт персональные данные следующим категориям получателей:',
    },
    {
      kind: 'bullet',
      text: 'а) хостинг-провайдеры и центры обработки данных, обеспечивающие хранение данных и бесперебойную работу инфраструктуры Приложения;',
    },
    {
      kind: 'bullet',
      text: 'б) платёжные системы и процессинговые сервисы, обеспечивающие проведение транзакций и возвратов (Google Play, App Store, Stripe, PayPal и иные агрегаторы);',
    },
    {
      kind: 'bullet',
      text: 'в) аналитические и технические партнёры, предоставляющие услуги по мониторингу, безопасности, модерации контента и улучшению пользовательского опыта;',
    },
    {
      kind: 'bullet',
      text: 'г) юридические и аудиторские консультанты, если обработка данных необходима для соблюдения законных интересов Компании;',
    },
    {
      kind: 'bullet',
      text: 'д) компетентные государственные органы на основании законных запросов, направленных в соответствии с применимыми процедурами.',
    },
    {
      kind: 'para',
      number: '4.3.',
      text: 'Все партнёры и подрядчики Компании обязаны соблюдать требования конфиденциальности и обеспечивать уровень защиты данных, эквивалентный требованиям GDPR и Законодательством Республики Абхазия. С каждым обработчиком заключается Договор об обработке данных (DPA) и Типовые договорные условия (SCC).',
    },
    {
      kind: 'para',
      number: '4.4.',
      text: 'Место хранения данных:',
    },
    {
      kind: 'bullet',
      text: 'а) Персональные данные Пользователей хранятся на серверах, расположенных в центрах обработки данных, обеспечивающих уровень безопасности не ниже ISO/IEC 27001.',
    },
    {
      kind: 'bullet',
      text: 'б) Основная инфраструктура Компании размещается на серверах хостинг-провайдера «Selectel» и иных операторов, предоставляющих международную инфраструктуру хранения данных, при условии соблюдения ими эквивалентного уровня защиты информации.',
    },
    {
      kind: 'para',
      number: '4.5.',
      text: 'Трансграничная передача данных осуществляется только при соблюдении одного из следующих условий:',
    },
    {
      kind: 'bullet',
      text: 'а) страна-получатель обеспечивает адекватный уровень защиты персональных данных в соответствии с решением Европейской комиссии или Роскомнадзора;',
    },
    {
      kind: 'bullet',
      text: 'б) Пользователь дал явное согласие на такую передачу;',
    },
    {
      kind: 'bullet',
      text: 'в) передача необходима для исполнения договора между Пользователем и Компанией;',
    },
    {
      kind: 'bullet',
      text: 'г) передача необходима для защиты жизненно важных интересов Пользователя или третьего лица;',
    },
    {
      kind: 'bullet',
      text: 'д) передача необходима для установления, осуществления или защиты правовых требований Компании.',
    },
    {
      kind: 'para',
      number: '4.6.',
      text: 'При передаче данных в страны, не обеспечивающие адекватный уровень защиты, Компания применяет дополнительные меры:',
    },
    {
      kind: 'bullet',
      text: 'шифрование данных при передаче и хранении;',
    },
    {
      kind: 'bullet',
      text: 'минимизация объёма передаваемой информации;',
    },
    {
      kind: 'bullet',
      text: 'аудит партнёров на соответствие стандартам.',
    },
    {
      kind: 'para',
      number: '4.7.',
      text: 'Срок хранения персональных данных определяется целями обработки:',
    },
    {
      kind: 'bullet',
      text: 'регистрационные данные и данные учётной записи хранятся до удаления аккаунта;',
    },
    {
      kind: 'bullet',
      text: 'платёжные данные хранятся в течение 5 лет для целей бухгалтерского учёта;',
    },
    {
      kind: 'bullet',
      text: 'анонимизированные аналитические данные — не более 24 месяцев.',
    },
    {
      kind: 'para',
      number: '4.8.',
      text: 'По достижении целей обработки персональные данные подлежат удалению или обезличиванию, если их дальнейшее хранение не требуется для выполнения обязательств Компании, урегулирования споров или соблюдения законодательных требований.',
    },
    {
      kind: 'para',
      number: '4.9.',
      text: 'Если Пользователь прекращает использование Приложения, его персональные данные подлежат удалению в течение 30 календарных дней с даты подтверждения удаления учётной записи, за исключением данных, которые Компания обязана хранить в силу закона.',
    },
    {
      kind: 'heading',
      number: '5.',
      text: 'Защита и безопасность персональных данных',
    },
    {
      kind: 'para',
      number: '5.1.',
      text: 'Компания принимает все необходимые правовые, организационные и технические меры для обеспечения безопасности и конфиденциальности персональных данных, предотвращения несанкционированного доступа, изменения, утраты, уничтожения, распространения или иных неправомерных действий.',
    },
    {
      kind: 'para',
      number: '5.2.',
      text: 'Используемые меры включают:',
    },
    {
      kind: 'bullet',
      text: 'а) Шифрование данных — все передаваемые и хранимые персональные данные защищены с использованием современных методов шифрования;',
    },
    {
      kind: 'bullet',
      text: 'б) Изоляция данных — персональные данные хранятся в сегментированных базах данных с ограничением доступа по принципу need-to-know (необходимости знать);',
    },
    {
      kind: 'bullet',
      text: 'в) Контроль доступа — доступ к данным предоставляется только уполномоченным сотрудникам и подрядчикам, подписавшим соглашения о неразглашении (NDA) и прошедшим обучение по информационной безопасности;',
    },
    {
      kind: 'bullet',
      text: 'г) Многоуровневая аутентификация и аудит действий — все операции с персональными данными фиксируются в журналах безопасности (аудит-логах), которые регулярно проверяются внутренним отделом комплаенс;',
    },
    {
      kind: 'bullet',
      text: 'д) Резервное копирование и восстановление данных — ежедневное создание зашифрованных резервных копий и их хранение в изолированных хранилищах с ограниченным доступом;',
    },
    {
      kind: 'bullet',
      text: 'е) Регулярное тестирование безопасности (пентесты) — ежегодное проведение внешнего аудита и тестирования защиты системы независимыми специалистами;',
    },
    {
      kind: 'bullet',
      text: 'ж) Мониторинг инцидентов и реагирование — круглосуточная система безопасности фиксирует попытки несанкционированного доступа, а команда обеспечивает оперативное устранение инцидентов.',
    },
    {
      kind: 'para',
      number: '5.3.',
      text: 'В случае утечки или несанкционированного доступа к персональным данным Компания:',
    },
    {
      kind: 'bullet',
      text: 'немедленно принимает меры по ограничению последствий;',
    },
    {
      kind: 'bullet',
      text: 'уведомляет компетентный орган по защите данных в течение 72 часов с момента обнаружения инцидента;',
    },
    {
      kind: 'bullet',
      text: 'информирует пострадавших Пользователей, если нарушение может представлять высокий риск для их прав и свобод, с указанием характера инцидента и принятых мер.',
    },
    {
      kind: 'para',
      number: '5.4.',
      text: 'Компания внедрила внутреннюю систему управления информационной безопасностью, основанную на международных стандартах. Данная система обеспечивает контроль рисков, аудит обработки данных и постоянное повышение уровня безопасности.',
    },
    {
      kind: 'para',
      number: '5.5.',
      text: 'Пользователь также несёт ответственность за безопасность своих данных и обязан:',
    },
    {
      kind: 'bullet',
      text: 'сохранять конфиденциальность своего пароля и данных авторизации;',
    },
    {
      kind: 'bullet',
      text: 'использовать сложные пароли и уникальные устройства аутентификации;',
    },
    {
      kind: 'bullet',
      text: 'не передавать свою учётную запись третьим лицам;',
    },
    {
      kind: 'bullet',
      text: 'своевременно обновлять программное обеспечение и антивирусную защиту.',
    },
    {
      kind: 'para',
      number: '5.6.',
      text: 'В случае нарушения правил безопасности Пользователем Компания не несёт ответственности за любую утрату или раскрытие данных, произошедшие в результате действий Пользователя.',
    },
    {
      kind: 'para',
      number: '5.7.',
      text: 'Любые запросы, связанные с безопасностью и конфиденциальностью данных, следует направлять на адрес privacy@aura-vibe.site с темой письма «Data Protection Inquiry» («Запрос по защите данных»).',
    },
    {
      kind: 'heading',
      number: '6.',
      text: 'Права пользователей и порядок их реализации',
    },
    {
      kind: 'para',
      number: '6.1.',
      text: 'В качестве субъекта персональных данных Пользователь обладает всеми правами, предусмотренными применимым законодательством, включая, но не ограничиваясь:',
    },
    {
      kind: 'bullet',
      text: 'а) право на информирование — получать чёткую и прозрачную информацию об обработке своих данных, включая цели, категории, сроки хранения и получателей;',
    },
    {
      kind: 'bullet',
      text: 'б) право доступа — получать подтверждение обработки своих персональных данных и копию обрабатываемой информации;',
    },
    {
      kind: 'bullet',
      text: 'в) право на исправление — требовать корректировки неточных или устаревших данных, а также дополнения неполной информации;',
    },
    {
      kind: 'bullet',
      text: 'г) право на удаление — требовать удаления своих персональных данных, если:',
    },
    {
      kind: 'para',
      text: 'О данные больше не необходимы для целей, для которых они были собраны;',
    },
    {
      kind: 'para',
      text: 'О Пользователь отозвал своё согласие и отсутствуют иные правовые основания для обработки;',
    },
    {
      kind: 'para',
      text: 'О Пользователь возражает против обработки и отсутствуют преобладающие законные интересы Компании;',
    },
    {
      kind: 'para',
      text: 'О обработка осуществлялась незаконно;',
    },
    {
      kind: 'bullet',
      text: 'д) право на ограничение обработки — требовать временного прекращения операций с данными в случае спора относительно их точности, законности или необходимости хранения;',
    },
    {
      kind: 'bullet',
      text: 'е) право на переносимость данных — получать персональные данные, предоставленные Компании, в структурированном, общеупотребимом и машиночитаемом формате и передавать их другому оператору;',
    },
    {
      kind: 'bullet',
      text: 'ж) право на возражение против обработки — в любое время возражать против обработки данных, осуществляемой на основании законных интересов Компании, включая',
    },
    {
      kind: 'para',
      text: 'обработку в маркетинговых или аналитических целях;',
    },
    {
      kind: 'bullet',
      text: 'з) право не подвергаться автоматизированному принятию решений — требовать, чтобы решения, имеющие юридические последствия, не принимались исключительно на основании автоматизированной обработки (включая профилирование);',
    },
    {
      kind: 'bullet',
      text: 'и) право отозвать согласие в любое время без ущерба для законности обработки, осуществлённой до отзыва;',
    },
    {
      kind: 'bullet',
      text: 'к) право на подачу жалобы — обращаться в компетентный орган по защите данных в своей стране или в суд, если Пользователь считает, что его права были нарушены.',
    },
    {
      kind: 'para',
      number: '6.2.',
      text: 'Для реализации указанных прав Пользователь может направить запрос:',
    },
    {
      kind: 'bullet',
      text: 'по электронной почте на адрес privacy@aura-vibe.site с темой письма «Data Subject Request» («Запрос субъекта данных»);',
    },
    {
      kind: 'bullet',
      text: 'через встроенную форму «Запрос персональных данных» в Приложении;',
    },
    {
      kind: 'bullet',
      text: 'письмом по адресу: ООО «Falcon», проспект Мира 16, г. Сухум, Республика Абхазия.',
    },
    {
      kind: 'para',
      number: '6.3.',
      text: 'Компания рассматривает запросы Пользователей в течение 30 (тридцати) календарных дней с даты получения. При необходимости уточнения информации или идентификации заявителя срок может быть продлён, но не более чем ещё на 30 дней, о чём Пользователь уведомляется в письменной форме.',
    },
    {
      kind: 'para',
      number: '6.4.',
      text: 'В целях защиты персональных данных от несанкционированного доступа Компания может запросить документ или иную информацию, подтверждающую личность заявителя.',
    },
    {
      kind: 'para',
      number: '6.5.',
      text: 'Ответ предоставляется в электронной форме (по электронной почте), если Пользователь не запросил иной способ. Отказы в удовлетворении запроса оформляются в письменной форме с указанием правовых оснований.',
    },
    {
      kind: 'para',
      number: '6.6.',
      text: 'Отзыв согласия на обработку данных может повлечь частичное или полное ограничение функциональности Приложения, если такая обработка необходима для предоставления соответствующих услуг.',
    },
    {
      kind: 'para',
      number: '6.7.',
      text: 'Компания не взимает плату за обработку запросов, за исключением случаев, когда запросы являются явно необоснованными или чрезмерными (например, повторные без новых оснований).',
    },
    {
      kind: 'heading',
      number: '7.',
      text: 'Файлы cookie, аналитика и маркетинг',
    },
    {
      kind: 'para',
      number: '7.1.',
      text: 'Для улучшения удобства использования Приложения и качества его услуг Компания использует файлы cookie и иные аналогичные технологии (пиксели, теги, локальное хранилище браузера).',
    },
    {
      kind: 'para',
      number: '7.2.',
      text: 'Данные файлов cookie обрабатываются в соответствии с Политикой использования файлов cookie Компании, доступной по адресу:.',
    },
    {
      kind: 'heading',
      number: '8.',
      text: 'Сроки хранения и удаления персональных данных',
    },
    {
      kind: 'para',
      number: '8.1.',
      text: 'Персональные данные Пользователей хранятся только в течение периода, необходимого для достижения целей, для которых они были собраны, или в течение срока, установленного законодательством страны, под юрисдикцией которой осуществляется обработка.',
    },
    {
      kind: 'para',
      number: '8.2.',
      text: 'Конкретные сроки хранения определяются следующим образом:',
    },
    {
      kind: 'para',
      text: 'Категория данных',
    },
    {
      kind: 'para',
      text: 'Цель обработки',
    },
    {
      kind: 'para',
      text: 'Срок хранения',
    },
    {
      kind: 'para',
      text: 'Регистрационные данные (имя, эл. почта, номер телефона, возраст, страна)',
    },
    {
      kind: 'para',
      text: 'Идентификация пользователя, доступ к сервису',
    },
    {
      kind: 'para',
      text: 'До удаления учётной записи или 5 лет с даты',
    },
    {
      kind: 'para',
      text: 'последней активности',
    },
    {
      kind: 'para',
      text: 'Пользовательский контент(публикации, фото, видео, комментарии)',
    },
    {
      kind: 'para',
      text: 'Функционирование социальных разделов Приложения',
    },
    {
      kind: 'para',
      text: 'До удаления Пользователем или до истечения срока хранения резервных копий (до 90 дней)',
    },
    {
      kind: 'para',
      text: 'Технические и аналитические данные (cookie, журналы, SDK- идентификаторы)',
    },
    {
      kind: 'para',
      text: 'Аналитика, безопасность, улучшение сервиса',
    },
    {
      kind: 'para',
      text: 'Не более 24 месяцев',
    },
    {
      kind: 'para',
      text: 'Платёжные и транзакционные данные',
    },
    {
      kind: 'para',
      text: 'Финансовая отчётность и налоговые обязательства',
    },
    {
      kind: 'para',
      text: '5 лет с даты транзакции',
    },
    {
      kind: 'para',
      text: 'Документы для проверки личности',
    },
    {
      kind: 'para',
      text: 'Подтверждение возраста или статуса',
    },
    {
      kind: 'para',
      text: 'До завершения процесса верификации, затем удаляются в течение 30 дней',
    },
    {
      kind: 'para',
      text: 'Переписка со службой поддержки',
    },
    {
      kind: 'para',
      text: 'Разрешение запросов, предоставление доказательств',
    },
    {
      kind: 'para',
      text: '2 года с даты закрытия запроса',
    },
    {
      kind: 'para',
      text: 'Резервные копии данных',
    },
    {
      kind: 'para',
      text: 'Восстановление после инцидентов',
    },
    {
      kind: 'para',
      text: 'До 90 дней, затем автоматическое удаление',
    },
    {
      kind: 'para',
      number: '8.3.',
      text: 'По истечении указанных сроков данные подлежат удалению или обезличиванию, если их дальнейшее хранение не требуется для:',
    },
    {
      kind: 'bullet',
      text: 'а) выполнения договорных обязательств Компании;',
    },
    {
      kind: 'bullet',
      text: 'б) урегулирования претензий и споров;',
    },
    {
      kind: 'bullet',
      text: 'в) соблюдения законодательных требований (включая бухгалтерский и налоговый учёт).',
    },
    {
      kind: 'para',
      number: '8.4.',
      text: 'Персональные данные удаляются одним из следующих способов:',
    },
    {
      kind: 'bullet',
      text: 'полное уничтожение данных из активного и резервного хранилищ;',
    },
    {
      kind: 'bullet',
      text: 'программное обезличивание (анонимизация) без возможности последующей идентификации Пользователя;',
    },
    {
      kind: 'bullet',
      text: 'физическое уничтожение носителей данных, если данные хранились в офлайн-режиме.',
    },
    {
      kind: 'para',
      number: '8.5.',
      text: 'При удалении учётной записи Пользователя в Приложении:',
    },
    {
      kind: 'bullet',
      text: 'а) все персональные данные, за исключением тех, которые должны храниться по закону, удаляются в течение 30 (тридцати) календарных дней;',
    },
    {
      kind: 'bullet',
      text: 'б) данные, включённые в резервную копию, автоматически удаляются в течение 90 дней после удаления основного массива.',
    },
    {
      kind: 'para',
      number: '8.6.',
      text: 'Обезличенные статистические и аналитические данные, не позволяющие установить личность Пользователя, могут храниться бессрочно в целях исследований и улучшения сервиса.',
    },
    {
      kind: 'para',
      number: '8.7.',
      text: 'Пользователь имеет право запросить подтверждение удаления или обезличивания своих данных, направив запрос на адрес: privacy@aura-vibe.site.',
    },
    {
      kind: 'heading',
      number: '9.',
      text: 'Изменения Политики и уведомление пользователей',
    },
    {
      kind: 'para',
      number: '9.1.',
      text: 'Компания имеет право вносить изменения и дополнения в настоящую Политику в одностороннем порядке, если это вызвано:',
    },
    {
      kind: 'bullet',
      text: 'а) изменениями функциональности Приложения или используемых технологий;',
    },
    {
      kind: 'bullet',
      text: 'б) обновлением законодательных требований стран, в которых действует Компания;',
    },
    {
      kind: 'bullet',
      text: 'в) уточнением целей и оснований обработки персональных данных;',
    },
    {
      kind: 'bullet',
      text: 'г) изменениями в структуре или политике Компании.',
    },
    {
      kind: 'para',
      number: '9.2.',
      text: 'Новая версия Политики вступает в силу с момента её публикации на официальном сайте https://aura-vibe.site/privacy_policy и/или в Приложении, если иное не предусмотрено самой Политикой.',
    },
    {
      kind: 'para',
      number: '9.3.',
      text: 'При внесении существенных изменений, которые могут затронуть права и интересы Пользователей, Компания обязуется уведомить Пользователей одним или несколькими способами:',
    },
    {
      kind: 'bullet',
      text: 'размещение уведомления в Приложении или на сайте;',
    },
    {
      kind: 'bullet',
      text: 'направление письма на адрес электронной почты, указанный при регистрации;',
    },
    {
      kind: 'bullet',
      text: 'отображение всплывающего уведомления при следующем открытии Приложения.',
    },
    {
      kind: 'para',
      number: '9.4.',
      text: 'Пользователь обязан ознакомиться с действующей версией Политики. Продолжение использования Приложения после вступления изменений в силу означает согласие Пользователя с новой версией Политики.',
    },
    {
      kind: 'para',
      number: '9.5.',
      text: 'Если Пользователь не согласен с изменениями, он имеет право прекратить использование Приложения и запросить удаление своих персональных данных в порядке, предусмотренном разделом 8 настоящей Политики.',
    },
    {
      kind: 'para',
      number: '9.6.',
      text: 'Компания хранит все предыдущие версии Политики в течение не менее пяти (5) лет с даты окончания их действия. Архивные версии предоставляются по запросу Пользователя или компетентных органов.',
    },
    {
      kind: 'heading',
      number: '10.',
      text: 'Контактные данные и порядок',
    },
    {
      kind: 'heading',
      text: 'обработки запросов пользователей',
    },
    {
      kind: 'para',
      number: '10.1.',
      text: 'Все вопросы, связанные с обработкой, хранением, уточнением, удалением или передачей персональных данных, а также реализацией прав, указанных в разделе 6 настоящей Политики, могут быть направлены Пользователем следующими способами:',
    },
    {
      kind: 'bullet',
      text: 'по электронной почте: privacy@aura-vibe.site — для запросов, связанных с персональными данными (запросы субъектов данных, запросы в соответствии с GDPR;',
    },
    {
      kind: 'bullet',
      text: 'по электронной почте: support@aura-vibe.site — для общих запросов и технических вопросов;',
    },
    {
      kind: 'bullet',
      text: 'почтовым отправлением: ООО «Falcon» проспект Мира 16, г. Сухум, Республика Абхазия.',
    },
    {
      kind: 'para',
      number: '10.2.',
      text: 'Компания назначила лицо, ответственное за организацию обработки персональных данных, для контроля за соблюдением требований конфиденциальности и взаимодействия с надзорными органами.',
    },
    {
      kind: 'para',
      text: 'Контактное лицо:.',
    },
    {
      kind: 'para',
      number: '10.3.',
      text: 'Запрос должен содержать:',
    },
    {
      kind: 'bullet',
      text: 'а) фамилию, имя, адрес электронной почты или номер телефона Пользователя;',
    },
    {
      kind: 'bullet',
      text: 'б) краткое описание сути запроса или претензии;',
    },
    {
      kind: 'bullet',
      text: 'в) при необходимости — документы, подтверждающие личность и право на подачу запроса.',
    },
    {
      kind: 'para',
      number: '10.4.',
      text: 'Компания рассматривает запросы в течение 30 (тридцати) календарных дней с даты получения. Если запрос требует дополнительной проверки или взаимодействия с партнёрами, срок может быть продлён, но не более чем ещё на 30 дней, о чём Пользователь будет уведомлён.',
    },
    {
      kind: 'para',
      number: '10.5.',
      text: 'Пользователь имеет право подать жалобу в компетентный орган по защите данных в своей стране, если считает, что его права были нарушены.',
    },
    {
      kind: 'para',
      number: '10.6.',
      text: 'Все запросы и обращения, связанные с защитой персональных данных, рассматриваются Компанией в приоритетном порядке и документируются в журнале.',
    },
    {
      kind: 'para',
      number: '10.7.',
      text: 'Компания подтверждает, что все запросы Пользователей касательно защиты персональных данных рассматриваются бесплатно и в строгом соответствии с принципами законности, справедливости и добросовестности.',
    },
  ],
};
